import React, { useEffect, useState, useMemo } from 'react'
import { dataTableRender, sleep } from '../components/functions'
import { useHistory } from 'react-router-dom'
import api from '../components/api';
import moment from 'moment'



import MaterialReactTable from 'material-react-table';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';


import "@fortawesome/fontawesome-free/css/all.min.css";




const Eventos = () => {


    const history = useHistory();


    var [resultado, setResultado] = useState([])
    var [evento_id, setEvento_id] = useState()





    const columns = useMemo(
        () => [
           {
            accessorKey: "data_inicio",
            header: "Data início",
            accessorFn: (row) => {
                const [day, month, year] = row.data_inicio.split("/");
                // Cria Date no horário local para evitar deslocamento de fuso
                return new Date(year, month - 1, day);
            },
            Cell: ({ cell }) => {
                const date = cell.getValue(); // objeto Date criado no horário local
                return moment(date).format("DD/MM/YYYY"); // formata para string BR
            },
            sortingFn: "datetime",
            muiTableHeadCellProps: {
                align: "center",
            },
            muiTableBodyCellProps: {
                align: "center",
            },
           },

          
          {
            accessorKey: 'nome',
            header: 'Evento',
          },
          {
            accessorKey: 'totalInscritos',
            header: 'Inscritos',
          },
          

        ],
        [],
      );



    useEffect(() => {

        if (evento_id) {

            history.push(`/Evento/${evento_id}`)

        }

    }, [evento_id])


    async function carregaEventos() {


        await api.get('eventos').then((result) => {

            //console.log(result.data)

            /*
            setResultado(result.data.map((rs) => 

                <tr style={{ cursor: 'pointer'}} onClick={() => setEvento_id(rs.evento_id)}>
                    <td>
                        {rs.dataISO}
                    </td>
                    <td>
                        {rs.nome}
                    </td>
                    <td>
                        {rs.totalInscritos}
                    </td>
                </tr>
            
            ))

            dataTableRender('tabelaEventos')
            */
           setResultado(result.data)

        }).catch((err) => {

            console.log(err.response)

        })

        


    }


    async function geraExcelAutorizaDados() {


        //return false

        window.toastr.info('Aguarde, gerando XLSX...')

        await api.get('usuariosAutorizaDadosXLS').then((result) => {

            console.log(result.data)

            if (result.data.status == 'ok') {

                sleep(1000).then(() => {

                    //console.log(result.data[0].fileNameCompleto, '!!')
                    //window.location.href = result.data.arquivo
                    window.location.href = `https://cdn.hospitaissaudaveis.org/${result.data.arquivo}`

                })
                

            }

        }).catch((err) => {

            console.log(err.response)

        })

    }


    useEffect(() => {

        carregaEventos()

    }, [])




    return (

        <div>
             <div class='content-header'>
                <div class='header-icon'>
                    <i class='pe-7s-date'></i>
                </div>
                <div class='header-title'>
                    <h1>Eventos</h1>
                    <small>Administração</small>
                    
                </div>
            </div>


            <div className="row">

                <div class="col-md-12">

                    
                    <button type="button" onClick={() => history.push('/Evento/Novo')} class="btn btn-info" >+ Novo Evento</button>&nbsp;
                    <button type="button" onClick={() => geraExcelAutorizaDados()} class="btn btn-success" >XLS participantes autoriza uso de dados</button>&nbsp;
                    
                    <br/><br/>

                </div>

                <div className="col-sm-12"  style={{ display: resultado ? 'block' : 'none'}}>
                    <div className="panel panel-bd lobidrag">
                        <div className="panel-heading" style={{ display: 'none'}}>
                            <div className="panel-title">
                                <h4>DataTables with HTML5 export buttons </h4>
                            </div>
                        </div>
                        <div class="panel-body">
                            
                            <div className="table-responsive">
                                

                            <MaterialReactTable 

                                columns={columns} 
                                data={resultado} 
                                localization={MRT_Localization_PT_BR}
                                //rowsPerPage={20}
                                //options={options}
                                initialState={{ 
                                    density: 'compact',
                                    pagination: {
                                                    pageSize: 15,
                                                    pageIndex: 0,
                                                },
                                    sorting: [
                                        {
                                          id: 'data_inicio', //sort by age by default on page load
                                          desc: true,
                                        },
                                        
                                      ],
                                }}

                                muiTableHeadCellProps={{
                                    //easier way to create media queries, no useMediaQuery hook needed.
                                    sx: {
                                    fontSize: {
                                        xs: '8px',
                                        sm: '9px',
                                        md: '10px',
                                        lg: '11px',
                                        xl: '12px',
                                    },
                                    },
                                }}
                                muiTableBodyCellProps={{
                                    sx: {
                                        fontSize: {
                                        xs: '8px',
                                        sm: '9px',
                                        md: '10px',
                                        lg: '11px',
                                        xl: '12px',
                                        },
                                    },
                                }}
                                muiTableBodyRowProps={({ row }) => ({
                                onClick: (event) => {
                                    //console.info(event, row.original.usuario_id);
                                    history.push(`/Evento/${row.original.evento_id}`)
                                    //window.$('.modal-MovimentoEdit').modal('show');setMovimento_id(row.original.movimento_id)
                                    //history.push(`AdesaoInstitucional/${row.original.adesao_institucional_id}`)
                                    //setAno(row.original.anoPerfil ? row.original.anoPerfil : row.original.anoDesafio); setAdesaoInstitucionalId(row.original.adesao_institucional_id); setResiduo_id(row.original.residuo_id); window.$("#modalResiduos").modal('show')
                                    //setAno(row.original.anoPerfil ? row.original.anoPerfil : row.original.anoDesafio); setAdesaoInstitucionalId(row.original.adesao_institucional_id); setEnergia_id(row.original.energia_id); window.$("#modalEnergia").modal('show')
                                    //categoria_adesao == 'G' ? '#modalPerfilAnualCorp' : '#modalPerfilAnual' } onClick={() => 
                                    //setAdesaoInstitucionalId(row.original.adesao_institucional_id);setAno(row.original.ano);window.$(`${ row.original.categoria_adesao == 'G' ? '#modalPerfilAnualCorp' : '#modalPerfilAnual' }`).modal('show')
                                    //data-target="#modalInscritoEvento" onClick={() => { setInscricao_id(rs.inscricao_id); setCPF(rs.cpf)}}
                                    //setInscricao_id(row.original.inscricao_id); setCPF(row.original.cpf);window.$('#modalInscritoEvento').modal('show')
                                },
                                sx: {
                                    cursor: 'pointer', //you might want to change the cursor too when adding an onClick
                                },
                                })}
                                />
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>



        </div>

    )

}

export default Eventos